import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)
const routes = [
    // ******** UserPages START ******** //
    {
        path: '/',
        name: 'Home',
        redirect: '/credit',
        component: Home
    },
    {
        path: '/credit',
        name: 'Credit',
        meta: {
            title: '信誉分'
        },
        component: () => import('@/views/Credit')
    },
    {
        path: '/inviteFriends',
        name: 'InviteFriends',
        meta: {
            title: '开盲盒，抽万元锦鲤大礼包'
        },
        component: () => import('@/views/inviteFriends')
    },
    {
        path: '/inviteRegisterSuccess',
        name: 'inviteRegisterSuccess',
        meta: {
            title: '下载APP'
        },
        component: () => import('@/views/inviteRegisterSuccess')
    },
    {
        path: '/turntable',
        name: 'Turntable',
        meta: {
            title: '抽奖活动'
        },
        component: () => import('@/views/Turntable')
    },
    {
        path: '/writeOff',
        name: 'writeOff',
        meta: {
            title: '抽奖活动'
        },
        component: () => import('@/views/WriteOff')
    },
    {
        path: '/invite',
        name: 'Invite',
        meta: {
            title: '邀请好友'
        },
        component: () => import('@/views/Invite')
    },
    {
        path: '/inviteRegis',
        name: 'InviteRegis',
        meta: {
            title: '邀请好友'
        },
        component: () => import('@/views/InviteRegis')
    },
    {
        path: '/inviteSuccess',
        name: 'InviteSuccess',
        meta: {
            title: '下载APP'
        },
        component: () => import('@/views/InviteSuccess')
    },
    {
        path: '/helper',
        name: 'Helper',
        meta: {
            title: '帮助中心'
        },
        component: () => import('@/views/fakeMini/problem')
    },
    {
        path: '/helper/:id',
        name: 'HelperTwo',
        meta: {
            // title: '帮助中心'
        },
        component: () => import('@/views/fakeMini/proDetail')
    },
    {
        path: '/pdf',
        name: 'pdf',
        meta: {
            // title: '帮助中心'
        },
        component: () => import('@/views/fakeMini/pdf')
    },
    {
        path: '/helper_dy',
        name: 'HelperDy',
        meta: {
            title: '获取链接',
            alias: '抖音'
        },
        component: () => import('@/views/helper/dy')
    },
    {
        path: '/helper_dzdp',
        name: 'HelperDZDP',
        meta: {
            title: '获取链接',
            alias: '大众点评'
        },
        component: () => import('@/views/helper/dzdp')
    },
    {
        path: '/helper_ks',
        name: 'HelperKS',
        meta: {
            title: '获取链接',
            alias: '快手'
        },
        component: () => import('@/views/helper/ks')
    },
    {
        path: '/helper_xhs',
        name: 'HelperXHS',
        meta: {
            title: '获取链接',
            alias: '小红书'
        },
        component: () => import('@/views/helper/xhs')
    },
    {
        path: '/helper_sina',
        name: 'HelperSina',
        meta: {
            title: '获取链接',
            alias: '新浪微博'
        },
        component: () => import('@/views/helper/sina')
    },
    {
        path: '/userRule',
        name: 'UserRule',
        meta: {
            title: '用户协议'
        },
        component: () => import('@/views/UserRule')
    },
    {
        path: '/privacy_agreement',
        name: 'PrivacyAgreement',
        meta: {
            title: '隐私协议'
        },
        component: () => import('@/views/PrivacyAgreement')
    },
    {
        path: '/about',
        name: 'About',
        meta: {
            title: '关于我们'
        },
        component: () => import('../views/About.vue')
    },
    {
        path: '/download',
        name: 'Download',
        meta: {
            title: 'App下载'
        },
        component: () => import('../views/Download.vue')
    },
    // ******** UserPages END ******** //
    // ******** UserPages START ******** //
    // 登录
    {
        path: '/companyLogin/:taskApplyId',
        name: 'CompanyLogin',
        meta: {
            title: '登录'
        },
        component: () => import('../views/CompanyLogin.vue')
    },{
        // 优惠券核销登录页面;
        path: '/copupCompanyLogin',
        name: 'CopupCompanyLogin',
        meta: {
            title: '登录'
        },
        component: () => import('../views/copupCompanyLogin.vue')
    },
    {
        // 券核销页面
        path: '/WriteOfferror',
        name: 'WriteOfferror',
        meta: {
            title: '券核销失败'
        },
        component: () => import('../views/WriteOfferror.vue')
    },
    {
        // 券核销页面
        path: '/confirmVerification',
        name: 'ConfirmVerification',
        meta: {
            title: '券核销'
        },
        component: () => import('../views/confirmVerification.vue')
    },
    {
        // 券核销页面
        path: '/VerificationRecord',
        name: 'VerificationRecord',
        meta: {
            title: '核销记录'
        },
        component: () => import('../views/VerificationRecord.vue')
    },{
        // 券核销页面
        path: '/WriteOffSuccess',
        name: 'WriteOffSuccess',
        meta: {
            title: '核销确认'
        },
        component: () => import('../views/WriteOffSuccess.vue')
    },
    // 登录
    {
        path: '/login',
        name: 'login',
        meta: {
            title: '登录'
        },
        component: () => import('../views/Login.vue')
    },
    // 仿小程序登录
    {
        path: '/minilogin',
        name: 'minilogin',
        meta: {
            title: '登录'
        },
        component: () => import('../views/fakeMini/login.vue')
    },
    {
        path: '/brandDetail/:id',
        name: 'brandDetail',
        meta: {
            title: '品牌详情'
        },
        component: () => import('../views/BrandDetail.vue')
    },
    // {
    //     path: '/help',
    //     name: 'help',
    //     meta: {
    //         title: '帮助中心'
    //     },
    //     component: () => import('../views/fakeMini/problem.vue')
    // },
    {
        path: '/instantTaskDetail',
        name: 'instantTaskDetail',
        meta: {
            title: '即刻任务详情'
        },
        component: () => import('../views/task/intantTaskDetail.vue')
    },
    {
        path: '/taskDetail/:id',
        name: 'taskDetail',
        meta: {
            title: '任务详情'
        },
        component: () => import('../views/task/taskDetail.vue')
    },
    {
        path: '/profitCode',
        name: 'profitCode',
        meta: {
            title: '权益核销'
        },
        component: () => import('../views/task/profitCode.vue')
    },
    {
        path: '/shop',
        name: 'Shop',
        meta: {
            title: '到店'
        },
        component: () => import('../views/Shop.vue')
    },
    {
        path: '/fail',
        name: 'Fail',
        meta: {
            title: '到店失败 '
        },
        component: () => import('../views/Fail.vue')
    },
    {
        path: '/succeed',
        name: 'Succeed',
        meta: {
            title: '到店成功 '
        },
        component: () => import('../views/Succeed.vue')
    },{
        path: '/ToStore',
        name: 'ToStore',
        meta: {
            title: '到店核销'
        },
        component: () => import('../views/ToStore.vue')
    },
    {
        path: '/profitFail',
        name: 'ProfitFail',
        meta: {
            title: '权益核销失败 '
        },
        component: () => import('../views/profitFail.vue')
    },
    {
        path: '/profitSucceed',
        name: 'ProfitSucceed',
        meta: {
            title: '权益核销成功 '
        },
        component: () => import('../views/profitSucceed.vue')
    },
    {
        path: '/table-stick',
        name: 'TableStick',
        meta: {
            title: '桌贴'
        },
        component: () => import('../views/TableStick.vue')
    },
    {
        path: '/brandList',
        name: 'BrandList',
        meta: {
            title: '品牌列表'
        },
        component: () => import('../views/instantTask/brandList')
    },
    {
        path: '/shopList',
        name: 'ShopList',
        meta: {
            title: '店铺列表'
        },
        component: () => import('../views/instantTask/shopList')
    },
    {
        path: '/shopDetail',
        name: 'ShopDetail',
        meta: {
            title: '店铺任务'
        },
        component: () => import('../views/instantTask/shopDetail')
    },
    {
        path: '/missionDetail',
        name: 'MissionDetail',
        meta: {
            title: '任务详情'
        },
        component: () => import('../views/instantTask/missionDetail')
    },
    {
        path: '/profitCancel/:id',
        name: 'ProfitCancel',
        meta: {
            title: '权益核销'
        },
        component: () => import('../views/instantTask/profitCancel')
    },{
        path:'/checkBox',
        name:'checkBox',
        // meta:{
        //     title:'每日签到'
        // },
        component:()=>import('../views/checkBox.vue')
    },{
        path:'/collectionRecord',
        name:'collectionRecord',
        meta:{
            title:'领取记录'
        },
        component:()=>import('../views/collectionRecord.vue')
    },{
        path:'/AddressList',
        name:'AddressList',
        meta:{
            title:'收货地址'
        },
        component:()=>import('../views/AddressList.vue')
    },{
        path:'/link',
        name:'link',
        meta:{
            title:'如何获取链接？'
        },
        component:()=>import('../views/link.vue')

    }
    // ******** UserPages START ******** //
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((route, redirect, next) => {
    if (route.meta.title) {
        document.title = route.meta.title
    } else if (route.name === 'Helper') {
        console.log(route)
        // document.title = route.query.routename
    }
    next()
})

export default router
